module.exports = __webpack_public_path__ + "static/media/vehicle-bg.cbc20b2d.png";